import React, { useState, useRef, useEffect } from 'react';
import { Switch, Empty, Table, Button, Col, Tag, Drawer, Form, Input, Row, Select, Space, message, Modal, Typography  } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import {getList as getAllTipoConcepts} from '../../../../apis/TipoConceptoApi';
import {insert, update, getById} from '../../../../apis/ConceptoApi';
import {conceptos_sat} from '@app/constants/concepto';
import _ from 'lodash';

const { Option } = Select;
const App = ({title, id, open, finish}) => {
    const [ form ] = Form.useForm()
    const [ID, setID] = useState(id);
    const [modified, setModified] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [searchedColumn, setSearchedColumn] = useState("");
    const [initialValues, setInitialValues] = useState(null);
    const [tipoConceptos, setTipoConceptos] = useState([]);
    const [concepts, setConcepts] = useState([]);
    const [conceptsSat, setConceptsSat] = useState([]);
    const [concept_sat, setConceptSat] = useState(null);
    const searchInput = useRef(null);
    
    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if(!values) return;
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            return;
        }

        const fields = form.getFieldsValue()
        if(ID > 0){
            //Update
            const payload = {
                id: ID,
                ...fields
            }
            const response = await update(payload);
            if(response.ok){
                message.success('Se actualizó correctamente el concepto!');
            }
        }else{
            //Create
            const payload = {
                id: ID,
                ...fields
            }
            const response = await insert(payload);
            if(response.ok){
                setID(response.payload);
                message.success('Se guardo correctamente el periodo!');
            }
        }

        setModified(true);
        onClose(true);
    }

    const onClose = (reload)=>{
      finish(reload ?? modified);
      setInitialValues(null);
    }

    const effectRan = useRef(false);
    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                await setConceptsSatFiltered();
                await getTipoConcepts();
                if(ID > 0){
                    await refreshData();
                }else{
                    setInitialValues({
                        tipo_concepto_id: null,
                        descripcion: null,
                        clave: null,
                        tiene_formula: false,
                        imprimir:false,
                        tipo_concepto_id: null,
                        concepto_sat: null,
                        activo: true
                    });
                }
                setModified(false)
            })();
        }
        return () => effectRan.current = true;
    }, []);


    useEffect(() => {
        (async () => {
            if(initialValues && initialValues.tipo_concepto_sat){
                await onChangeTipoConceptoSat(initialValues.tipo_concepto_sat)
            }
        })();
    }, [initialValues?.concepto_sat]);

    const setConceptsSatFiltered = async ()=>{
        const _conceptsSat = _.filter(conceptos_sat, (i)=>{
            return i.value == "c_TipoDeduccion" || i.value == "c_TipoPercepcion" || i.value == "c_TipoOtroPago" 
        });
        setConceptsSat(_conceptsSat);
    }

    const refreshData = async ()=> {
        const response = await getById(ID);
        if(response.ok){
            let concept = response.payload;
            setInitialValues(concept);
        }
    }

    const getTipoConcepts = async ()=>{
        const response = await getAllTipoConcepts();
        if(response.ok){
          let conceptsList = response.payload;
          if(conceptsList.length > 0)
            setTipoConceptos(conceptsList);
        }
    }

    const onChangeTipoConceptoSat = async (value)=>{
        var _concept_sat = _.find(conceptsSat, {value: value});
        setConceptSat(_concept_sat);
    }

    return (
        <Drawer
            title={title}
            width={720}
            placement={"right"}
            onClose={onClose}
            open={open}
            closable={true}
            extra={[
            <Space>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleOk} type="primary">
                Guardar
                </Button>
            </Space>]}
        >
            <>
                <div style={{height: 50}}>
                    <div style={{float: 'left'}}>
                        <span title=""></span>
                    </div>
                    <span class="" style={{float:'right'}}>
                        
                    </span>
                </div>
                {/* <PageHeader ghost={false} title="Remisiones" extra={[ 
                <Space>
                    <Button onClick={onClose}>Cancelar</Button>
                    <Button onClick={handleOk} type="primary">
                    Guardar
                    </Button>
                </Space>]} />*/}
            {
                initialValues && 
                <Form 
                        layout="vertical" 
                        form={form} 
                        hideRequiredMark 
                        autoComplete="off"
                        initialValues={initialValues} 
                        onFinish={handleOk}>
                        <Row gutter={16}>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="clave"
                                    label="Clave"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega una clave',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega un tipo" />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="descripcion"
                                    label="Descripción"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega una descripción',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega una descripción" />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="tipo_concepto_id"
                                    label="Tipo de Concepto"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor selecciona un tipo de concepto',
                                    },
                                    ]}
                                >
                                    <Select placeholder="Por favor selecciona un tipo de concepto">
                                        {
                                            tipoConceptos.map((item)=><Option value={item.value}>{item.text}</Option>)
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="imprimir"
                                    label="Imprimir"
                                    >
                                    <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="tiene_formula"
                                    label="Tiene Formula"
                                    >
                                    <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                                </Form.Item>
                            </Col>
                            {
                                conceptsSat && conceptsSat.length > 0 && 
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                    <Form.Item
                                        name="tipo_concepto_sat"
                                        label="Tipo de Concepto Sat"
                                        rules={[
                                        {
                                            required: false,
                                            message: 'Por favor selecciona un tipo de concepto',
                                        },
                                        ]}
                                    >
                                        <Select placeholder="Por favor selecciona un tipo de concepto" 
                                            showSearch
                                            filterOption={(input, option) =>
                                                (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            onChange={onChangeTipoConceptoSat}>
                                            <Option value={''}>Ninguno</Option>
                                            {
                                                conceptsSat.map((item)=><Option value={item.value}>{item.text}</Option>)
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>
                            }
                            {
                                concept_sat && 
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                    <Form.Item
                                        name="concepto_sat"
                                        label="Concepto Sat"
                                        rules={[
                                        {
                                            required: false,
                                            message: 'Por favor selecciona un concepto',
                                        },
                                        ]}
                                    >
                                        <Select 
                                            showSearch
                                            filterOption={(input, option) => {
                                                    return (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                                }
                                            }
                                            placeholder="Por favor selecciona un concepto">
                                            <Option value={''}></Option>
                                            {
                                                concept_sat.enumeration.map((item)=><Option value={item.value}>{'(' + item.value + ') ' + item.text}</Option>)
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>
                            }
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="activo"
                                    label="Activo"
                                    >
                                    <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                                </Form.Item>
                            </Col>
                        </Row>
                </Form>
            }
            </>
        </Drawer>
    );
};
export default App;